import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FormControlLabel, FormGroup, withStyles, Switch } from '@material-ui/core';
import { RootState } from 'state/store';
import { setIsOnScript } from 'state/script.state';
import { green } from '@material-ui/core/colors';

const OnScriptSwitch = withStyles({
  switchBase: {
    '&$checked': {
      color: green[500],
    },
    '&$checked + $track': {
      backgroundColor: green[500],
    },
  },
  checked: {},
  track: {},
})(Switch);

const OnOffScript = () => {
  const dispatch = useDispatch();
  const isOnScript = useSelector((state: RootState) => state.script.isOnScript);
  const currentStep = useSelector((state: RootState) => state.script.currentStepName);

  const handleChange = () => {
    const newOnScript = !isOnScript;
    const changeCurrentStep = newOnScript ? currentStep : null;

    dispatch(setIsOnScript({ isOnScript: newOnScript, onScriptStep: changeCurrentStep }));
  };

  return (
    <FormGroup row>
      <FormControlLabel
        control={<OnScriptSwitch checked={isOnScript} onChange={handleChange} size="small" />}
        label={isOnScript ? 'On Script' : 'Off Script'}
        labelPlacement="bottom"
      />
    </FormGroup>
  );
};

export default OnOffScript;
